import React, { useEffect, useMemo, useState } from 'react';
import { Guide } from '@/pages/home/components/Guide';
import { getLocale, useDispatch, useIntl, useLocation, useSelector } from 'umi';
import country_filter_cn from './imgs/cn/country_filter_cn@2x.png';
import country_filter_en from './imgs/en/country_filter_en@2x.png';

import game_store_trend_cn from './imgs/cn/game_store_trend_cn@2x.png';
import game_store_trend_en from './imgs/en/game_store_trend_en@2x.png';

import {
  OPINION_GUIDE_BOX_LIST3,
  OPINION_GUIDE_BOX_LIST3_PATH,
  OPINION_GUIDE_HIDE,
} from '@/pages/home/components/GuideModule/GuideOpinionBox';
import {
  GUIDE_TYPE_OPINION_GAME_STORE,
  GUIDE_SYS_OPINION,
} from '@/pages/home/models/guide';
import { storage } from '@/utils/utils';

import './index.scss';
import useOpinionGuideData from '@home/components/GuideModule/GuideOpinionBox/useOpinionGuideData';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
const GuideComponent = () => {
  const [currentGuideStep, setCurrentGuideStep] = useState(-3);
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const isEn = locale === 'en-US';
  const dispatch = useDispatch();
  const { guideType, userInfo, gameInfo } = useSelector((state: any) => {
    const {
      guide: { guideType },
      home: { userInfo },
      opinionCommon: { gameInfo },
    } = state;
    return {
      guideType,
      userInfo,
      gameInfo,
    };
  });

  const { excludeGuideSource } = useGetSingePageSourceRule({});
  const { GuideData } = useOpinionGuideData({
    gameInfo,
    userInfo,
    guidePermissions: excludeGuideSource,
  });

  // 注意下面两个useEffect不要合并到一起，不然会出现：从头部导航进入新手引导，点击到下一步时，关闭按钮无法关闭，而是返回到第一步
  useEffect(() => {
    if (guideType === GUIDE_TYPE_OPINION_GAME_STORE) {
      setCurrentGuideStep(0);
    }
  }, [guideType]);

  useEffect(() => {
    const list = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST3) || [];
    const guideHide = storage.getLocalStorageItem(OPINION_GUIDE_HIDE);
    if (userInfo?.openid && !list.includes(userInfo.openid) && !guideHide) {
      setCurrentGuideStep(0);
    }
  }, [userInfo]);

  const onFinished = () => {
    if (userInfo.openid) {
      const list = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST3) || [];
      !list?.includes(userInfo.openid) && list.push(userInfo.openid);
      storage.setLocalStorageItem(OPINION_GUIDE_BOX_LIST3, list);
    }
    dispatch({
      type: 'guide/showOpinionGuideModule',
      payload: true,
    });
  };

  const onCloseStep = () => {
    dispatch({
      type: 'guide/save',
      payload: {
        guideSys: GUIDE_SYS_OPINION,
        guideType: '',
      },
    });
  };

  const subtitle = formatMessage({
    id: 'Real-Time Ratings Across Global Game Stores',
  });
  const { blockList } = GuideData;
  const rank = blockList.findIndex((item) => item.tit === subtitle) + 1;
  const title = `${formatMessage({ id: 'Core Function' })} ${rank}`;

  const steps = useMemo(() => {
    const steps = [
      {
        element: () => {
          const ele = document.querySelector('.gamestore-table-setting');
          console.log('find ele', ele);
          return ele;
        },
        title,
        subtitle,
        description: formatMessage({
          id: 'Set the countries you are most concerned about and they will be displayed by default.',
        }),
        placement: 'left',
        bubbleStyle: {},
        extImage: {
          image: isEn ? country_filter_en : country_filter_cn,
          placement: 'bottom-start',
          style: {
            width: 541,
          },
        },
      },
      {
        highlightElements: [
          {
            element: () => document.querySelector('.gamestore-table-checkbox'),
            hasRadius: true,
          },
        ],
        element: () =>
          document
            .querySelector('.guide-table-two-row-box')
            ?.querySelector('.guide-table-two-cell-box') ||
          document
            .querySelectorAll('.dbo-regioncountry-table-row')?.[2]
            ?.querySelectorAll('td')?.[2],
        title,
        subtitle,
        description: formatMessage({
          id: 'Highlight the scores of countries in which the declines exceed the threshold and need attention.',
        }),
        placement: 'left',
        bubbleStyle: {},
        extImage: {
          image: isEn ? game_store_trend_en : game_store_trend_cn,
          placement: 'right',
          style: {
            width: 290,
            left: -300,
            top: 3,
            position: 'relative',
          },
        },
      },
    ];

    return steps;
  }, [currentGuideStep, locale]);

  if (guideType !== GUIDE_TYPE_OPINION_GAME_STORE) return null;

  return (
    // finishText 根据中英文调整
    <Guide
      current={currentGuideStep}
      onCurrentChange={(
        current: number,
        context: {
          from: 'start' | 'back' | 'next' | 'finish' | 'cancel' | 'nodata';
        },
      ) => {
        const { from } = context;
        setCurrentGuideStep(current);
        if (from === 'finish' || from === 'nodata') {
          onFinished();
        } else if (from === 'cancel') {
          onCloseStep();
          onFinished();
        }
      }}
      visibleCloseBtn
      hideCancelButton
      showBackButton
      nextButtonTheme="primary"
      backText={formatMessage({ id: 'guide_last_step' })}
      nextText={formatMessage({ id: 'guide_next_step' })}
      finishText={formatMessage({ id: 'guide_more_step' })}
      steps={steps}
      showLoading={false}
    />
  );
};

export default () => {
  const location = useLocation();

  return (
    <>
      {OPINION_GUIDE_BOX_LIST3_PATH === location.pathname && <GuideComponent />}
    </>
  );
};
